import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as Delete2Icon } from '@enamelai/design-system/icons/Delete2'

type CallFlowDeleteModalProps = {
  show: boolean
  callFlowName: string
  onCancel: () => void
  onDelete: () => void
  deleteDisabled?: boolean
}

const CallFlowDeleteModal: React.FC<CallFlowDeleteModalProps> = ({
  show,
  callFlowName,
  onCancel,
  onDelete,
  deleteDisabled = false,
}) => {
  const name = callFlowName.trim() || 'this call flow'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      closeOnBackdrop={false}
      size="sm"
      variant="confirmation"
      title="Delete call"
      icon={<Delete2Icon width={16} height={16} aria-hidden="true" />}
      iconTone="danger"
      description={[
        `Are you sure you want to permanently delete the call flow ${name}?`,
        'This action cannot be undone.',
      ]}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      primaryDisabled={deleteDisabled}
      onPrimaryClick={() => {
        onDelete()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    />
  )
}

export default CallFlowDeleteModal
